<template>
	<div>
    <pt-form-item label="审核结果:" labelWidth="80px" :required="true">
      <el-radio-group v-model="form.result">
        <el-radio label="QUALIFIED">通过</el-radio>
        <el-radio label="ABANDON_WAITING_FUTURE_ACTION">废弃</el-radio>
      </el-radio-group>
    </pt-form-item>
    <pt-form-item label="上传报告:" labelWidth="80px" :required="Boolean(fileValidate)">
       <el-upload ref="qualityFile" class="upload-demo" v-model="form.reportFile" name="reportFile" v-validate="fileValidate" data-vv-as="上传报告"
    action="aaa"
    :auto-upload="false"
    :multiple="true"
    :on-change="changHandler" :on-remove="removeHandler" accept="jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF">
      <el-button slot="trigger" size="small" type="primary">选择报告</el-button>
      <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload">上传报告</el-button>
    </el-upload>
    </pt-form-item>
	</div>
</template>

<script>
import { validate } from 'utils/validate'
import { AdultNext } from '../status.js'
import { getSignature } from '@/utils/action'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  data () {
    return {
      title: '报告审核',
      form: {
        result: 'QUALIFIED',
        checker: this.$auth.user().fullName,
        reportFile: []
      },
      saveFileName: [],
      pass: false,
      reasonObj: {
        have: false,
        reasons: []
      },
      PCR: this.order.isPcr,
      reportFiles: []
    }
  },
  computed: {
    showRadio () {
      let { workflow } = this.order
      if (workflow && workflow === 'REPORT_ONLY_UNLOCK') {
        // 解锁的时候不显示
        return false
      }
      return true
    },
    isThird () {
      return this.order.packageProductionType === 'THIRDPARTY'
    },
    fileValidate () {
      if (this.order.reportOssUrls && this.order.reportOssUrls.length) {
        return ''
      }
      return 'required'
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    changHandler (file, fileList) {
      this.form.reportFile = fileList.map(e => e.raw)
    },
    removeHandler (file, fileList) {
      this.form.reportFile = fileList.map(e => e.raw)
    },
    async uploadToOss (file) {
      let params = { resourceConfig: 'reports', type: 'PRIVATE_RESOURCE', objectId: this.order.sampleId, name: file.name }
      var response = await this.$store.dispatch('ossUploadBigFileAdult', params)
      let uploadParams = new FormData()
      uploadParams.append('AccessKeyId', response.data.accesskeyid)
      uploadParams.append('policy', response.data.policy)
      uploadParams.append('signature', response.data.signature)
      uploadParams.append('key', response.data.key)
      uploadParams.append('file', file)
      // uploadParams.append('x-obs-acl', response.data['x-obs-acl'])
      uploadParams.append('content-type', response.data['content-type'])
      // uploadParams.append('success_action_status', 200) // 指定返回的状态码，默认为204
      return getSignature(response.data.host, uploadParams)
    },
    async submitUpload () {
      if (!this.form.reportFile.length) {
        this.$message.error('请选择报告')
      } else {
        if (this.order.reportOssUrls && this.order.reportOssUrls.length) {
          this.$confirm('确认继续？', '此操作将替换原报告文件', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(_ => {
            this.commonUpload()
          })
        } else {
          this.commonUpload()
        }
      }
    },
    async commonUpload () {
      this.$emit('updateLoading', true)
      let promiseArr = this.form.reportFile.map(file => this.uploadToOss(file))
      let noUse = await Promise.all(promiseArr)
      console.log(noUse)
      let data = {
        id: this.order.id
      }
      data.reportOssUrls = this.form.reportFile.map((e) => 'reports/' + this.order.sampleId + '/' + e.name)
      this.$store.dispatch('AdultuploadReports', data).then(res => {
        this.form.reportFile = []
        this.$refs.qualityFile.clearFiles()
        this.$emit('on-error', false)
        this.$emit('on-success')
      }).catch(err => {
        this.$emit('on-error', false)
        this.$message.error(err)
      })
    },
    async next () {
      let data = { orderIds: [this.order.id], action: this.status }
      data.orderStatusDetail = {
        orderStatusResult: this.form.result
      }
      if (this.form.result === 'QUALIFIED' && !this.order.reportOssUrls) {
        this.$message.error('请先上传报告')
        this.$emit('on-error', false)
        return
      }
      if (this.form.reportFile.length) {
        console.log('this.form.reportFile', this.form.reportFile)
        this.$message.error('您选择的文件还未上传，请先上传')
        this.$emit('on-error', false)
        return
      }
      let promiseArr = this.form.reportFile.map(file => this.uploadToOss(file))
      let noUse = await Promise.all(promiseArr)
      console.log(noUse)
      data.orderStatusDetail.attachmentFileInformationList = this.form.reportFile.map((e, i) => {
        return {
          ossUrl: 'reports/' + this.order.sampleId + '/' + e.name,
          type: 'PACKAGE_REPORT',
          name: e.name
        }
      })
      return AdultNext.call(this, data)
    }
  },
  created () {

  }

}
</script>

<style lang="less">

</style>
